import { Component } from "react";
import { Modal } from "react-bootstrap";
import { popCancelBttn } from "../../assets";
import Button from "../Button";
import '../PopUp/GlobalSearchFeaturesPopUp.css'
import './GenAIPinToReadingListPopUp.css'
import ApiServices from "../../utils/apiServices";
import { snippetLongString } from "../../utils/utilityServices";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
class GenAIRenameReadingListPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rlName: '',
            rlID: '',
            showSuccess: false,
            showPop: false,
            error: '',
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            alertMessageIsError: false
        }
    }
    componentDidMount() {
        this.setState({
            showPop: this.props.showModal,
            rlName: this.props.rlName,
            rlID: this.props.rlID
        });
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#EB1700",
            alertMessageShowModal: true,
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#EB1700",
            alertMessageShowModal: true,
            alertMessageIsError: true
        })
    }
    closeAlertMessage = () => {
        const { alertMessageIsError, showPop } = this.state;
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            showPop: alertMessageIsError ? showPop : false,
            alertMessageShowModal: false,
            alertMessageIsError: false,
        })
        if (!alertMessageIsError) {
            this.props.handleClose(false)
        }
    }
    handleOnClickView = async (rlID, rName) => {

        let ids = "";
        let service = new ApiServices();
        let res = await service.getDocIds(rlID);
        if (res.length > 0) {
            ids = res.map(item => item.doc_id).filter(x => x).join(";");
            // res.map((item) => {
            //     ids += `${item.doc_id};`;
            //     return null;
            // });
        }
        localStorage.setItem("readListDocIds", ids);
        localStorage.setItem("rLID", rlID);
        localStorage.setItem("rName", rName);
        let url = `/viewReadingList?query=&q=All%20Fields&filters=&f1=searchID&fval1=${ids}&fcount=1&rName=${encodeURIComponent(
            rName
        )}&rID=${rlID}`;
        if (ids !== "") {
            window.open(url, "_blank");
        } else {
            this.errorAlertMessage("You do not have any items pinned to this reading list.");
        }


        // let ids = '';
        // let service = new ApiServices
        // let res = await service.getDocIds(rlID);
        // if (res.length > 0) {
        //     res.map((item) => { ids += `${item.doc_id};`; return null })
        // }
        // let url = `/results?query=&q=All%20Fields&filters=&f1=searchID&fval1=${ids}&fcount=1`
        // window.open(url, '_blank');
    }
    handleSuccessClose = (status) => {
        this.setState({
            showSuccess: status
        })
    }
    handleSave = async () => {
        if (this.handleValidation()) {
            let service = new ApiServices();
            let res = await service.updateReadingListName(this.state.rlID, this.state.rlName);
            if (res) {
                this.successAlertMessage('Reading List Name saved successfully');
            }
        }
    }
    handleInput = (e) => {
        e.target.value = snippetLongString(e.target.value);
        this.setState({
            rlName: e.target.value
        })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        let readingList = this.props.apiResponse.filter(x => x.readinglist_id !== this.state.rlID).map(data => data.readinglist_name.toLowerCase())
        if ((this.state.rlName.length <= 0
            || (this.state.rlName && this.state.rlName.trim().length <= 0))) {
            formIsValid = false;
            errors["pinReadingList"] = `Please enter a valid name to proceed.`;
        }
        if (readingList.includes(this.state.rlName.toLowerCase())) {
            formIsValid = false;
            errors["pinReadingList"] = `You already have a reading list with entered title. Please enter a new name.`;
        }
        this.setState({ error: errors });
        return formIsValid;
    }
    render() {
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        if (this.props.width <= 1000) {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        scrollable={true}
                    >
                        <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                            <div>
                                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left", padding: "0.5rem 0" }}>
                                    <div style={{ textAlign: "center", width: "100%", paddingTop: "1%" }}>
                                        <Modal.Title>
                                            <div className="actionItem-headerPart">
                                                Rename Reading List
                                            </div>
                                        </Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                    <table className="reading-list-view-wrapper">
                                        <tr><th>Reading List Name</th><th style={{ textAlign: "center" }}>Actions</th></tr>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "60%" }}><input type="text" value={this.state.rlName} onChange={this.handleInput} /><br /><div className="errorInvalidName">{this.state.error["pinReadingList"]}</div></td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}><span onClick={e => this.handleOnClickView(this.props.rlID, this.props.rlName)} title="View" style={{ marginRight: "5px" }} className="reading-list-action-text">View</span><span className="action-items-separate-divider"></span><span title="Save" onClick={e => this.handleSave()} className="reading-list-action-text">Save</span></td>
                                            </tr>
                                            <span className="length-info">Name with a maximum of 100 characters.</span>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <div className="reading-list-button-tablet-wrapper">
                                    <Button text="Cancel" customColor="#000000" action={() => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
        else {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        scrollable={true}
                    >
                        <div className="gen-ai-common-popup">
                            <div className="gen-ai-common-popup__top-row">
                                <div className="gen-ai-common-popup__tabs">
                                    <Modal.Title>
                                        <div className="actionItem-headerPart">
                                            Rename Reading List
                                        </div>
                                    </Modal.Title>
                                </div>

                                <div className="gen-ai-common-popup__icon-area" onClick={e => {
                                    this.setState({ showPop: false });
                                    this.props.handleClose(false);
                                }} aria-hidden="true">
                                    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>

                            <div className="gen-ai-common-rename-popup__body">
                                <Modal.Body scrollable={true}  style={{ minHeight: "25vh" }}>
                                    <table className="reading-list-view-wrapper">
                                        <tr><th>Reading List Name</th>
                                            {/* <th style={{ textAlign: "center" }}>Actions</th> */}
                                        </tr>
                                        <tbody>
                                            <tr className="gen-ai-common-rename-tbody-tr">
                                                <td className="gen-ai-common-rename-tbody-td" style={{ width: "90%" }}><input type="text" style={{ width: "100%" }} value={this.state.rlName} onChange={this.handleInput} /></td>
                                                <td className="gen-ai-common-rename-tbody-td" style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "10%" }}><span onClick={e => this.handleOnClickView(this.props.rlID, this.props.rlName)} title="View" style={{ marginRight: "5px" }} className="gen-ai-common-list-action-text">View</span>
                                                    {/* <span className="action-items-separate-divider"></span><span title="Save" onClick={e => this.handleSave()} className="reading-list-action-text">Save</span> */}
                                                </td>
                                            </tr>
                                            <div className="errorInvalidName">{this.state.error["pinReadingList"]}</div>
                                            <span className="length-info">Name with a maximum of 100 characters.</span>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                {/* <div className="reading-list-button-wrapper">
                                    <Button text="Cancel" customColor="#000000" action={() => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }} />   
                                </div> */}
                            </div>
                            <div className="gen-ai-common-popup__footer">
                                {/* <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--primary"
                                onClick={e => this.handleOnClickView(this.props.rlID, this.props.rlName)}>
                                View
                            </button> */}
                                <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline" onClick={() => {
                                    this.setState({ showPop: false });
                                    this.props.handleClose(false);
                                }}>
                                    Cancel
                                </button>
                                <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--primary"
                                    onClick={e => this.handleSave()} >
                                    Save
                                </button>
                            </div>
                        </div>
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
    }
}
export default GenAIRenameReadingListPopup;